import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { FC } from "react";

export enum PriceMode {
  PURCHASE_PRICE = "purchase",
  SELLING_PRICE = "selling",
  FIT_PRICE = "fit",
}

interface PriceModeSelectorProps {
  value: PriceMode;
  onChange: (value: PriceMode) => void;
}

const PriceModeSelector: FC<PriceModeSelectorProps> = ({ value, onChange }) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    size="small"
    onChange={(_, newValue: PriceMode | null) => {
      if (newValue !== null) {
        onChange(newValue);
      }
    }}
  >
    <ToggleButton value={PriceMode.PURCHASE_PRICE}>Cena zakupu</ToggleButton>
    <ToggleButton value={PriceMode.SELLING_PRICE}>Cena sprzedaży</ToggleButton>
    <ToggleButton value={PriceMode.FIT_PRICE}>Cena FIT</ToggleButton>
  </ToggleButtonGroup>
);

export default PriceModeSelector;
